import { formatDecimals } from "../../../utils/utils";
import "./CuadrePV.css";

const CuadrePV = ({ cierre, componentRef, company }: any) => {
  const formatDate = (dateString: string) => {
    return dateString.substring(0, 10).split("-").reverse().join("/");
  };

  // Cargar datos de la empresa
  const Line = ({ label, value }: any) => (
    <div className="row">
      <span className="label">{label}</span>
      <span className="dots" />
      <span className="value">{value}</span>
    </div>
  );

  return (
    <div className="ticket" ref={componentRef}>
      <div className="center bold">{company?.Name}</div>
      <div className="center">{company?.VAT_Registration_No}</div>
      <div className="center">{company?.City}</div>
      <div className="center">{company?.Phone_No ?? company?.Phone_No_2}</div>
      <div className="center">{company?.E_Mail}</div>

      <br />

      <div className="center title">CUADRE PUNTO DE VENTA</div>
      <div className="center">CAJA CERRADA CORRECTAMENTE</div>

      <br />

      <Line label="FECHA:" value={formatDate(cierre?.FechaDeCierre)} />
      <Line label={cierre?.Cajero} value={cierre?.No_tienda || cierre?.tpv} />
      <Line label="XXXXXX" value="IP: XXXX" />

      <div>HORARIO {cierre?.Turno}</div>

      <br />

      <div>Usted ha visto el cuadre ({cierre?.count}) veces</div>

      <br />

      <Line label="TICKET" value={cierre?.ticketCount} />
      <Line label="VENTAS" value={formatDecimals(cierre?.sales)} />
      <Line label="DESCUENTOS" value={formatDecimals(cierre?.discountAmount)} />
      <Line label="DEVOLUCIONES" value={formatDecimals(cierre?.return)} />
      <Line label="SUBTOTAL" value={formatDecimals(cierre?.subTotal)} />
      <Line label="IMPUESTOS" value="0.00" />
      <Line label="GIFT CARD IN" value="0.00" />
      <Line
        label="NETO A/VENTA"
        value={formatDecimals(cierre?.subTotal - cierre?.return)}
      />
      <Line
        label="APERTURA"
        value={formatDecimals(cierre?.ImporteDeApertura)}
      />
      <Line label="DEPOSITO" value="0.00" />

      <div className="divider"></div>

      <Line label="DEPOSITO BANCARIO" value="0.00" />
      <Line label="EFECTIVO" value={formatDecimals(cierre?.cash)} />
      <Line
        label="TARJETAS DE CREDITO"
        value={formatDecimals(cierre?.credit)}
      />
      <Line
        label="TOTAL TARJETA"
        value={formatDecimals(cierre?.credit)}
      />
    </div>
  );
};

export default CuadrePV;
